import { accommodationInfo } from "../data/content";
import "./Lodging.css";

export default function Lodging(): JSX.Element {
  return (
    <section className="lodging" id="lodging" aria-labelledby="lodging-title">
      <div className="container lodging__grid">
        <div className="lodging__intro">
          <p className="sectionEyebrow">Szállás</p>
          <h2 id="lodging-title">{accommodationInfo.title}</h2>
          <p>{accommodationInfo.description}</p>
        </div>
        <div className="lodging__details">
          <article>
            <p className="lodging__label">Szobadíj</p>
            <strong>{accommodationInfo.price}</strong>
          </article>
          <article>
            <p className="lodging__label">Reggeli</p>
            <strong>{accommodationInfo.breakfastPrice}</strong>
          </article>
          <article className="lodging__wide">
            <p className="lodging__label">Érkezés és távozás</p>
            <strong>{accommodationInfo.stayWindow}</strong>
          </article>
          <article className="lodging__wide">
            <p className="lodging__label">Fizetés</p>
            <strong>{accommodationInfo.paymentNote}</strong>
          </article>
        </div>
      </div>
    </section>
  );
}
